import { pubsub } from '@services';

class CartTotal extends HTMLElement {
  unsubscribers = [];
  totalPrice = this.querySelector('[data-cart-total-price]');
  totalPriceValue = parseInt(this.totalPrice.getAttribute('data-cart-total-price'));

  connectedCallback() {
    this.unsubscribers.push(
      pubsub.subscribe('cart:generated-shipping-rates', ({ checkedOption }) =>
        this.handleShippingRateChanged(checkedOption)
      ),
      pubsub.subscribe('cart:shipping-rate-changed', ({ checkedOption }) =>
        this.handleShippingRateChanged(checkedOption)
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribeCartShippingRateChanged();
  }

  handleShippingRateChanged(checkedOption) {
    const price = parseInt(checkedOption.dataset.deliveryInfoPrice);

    this.updateTotalPrice(price);
  }

  updateTotalPrice(price) {
    this.totalPrice.textContent = new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}`, {
      style: 'currency',
      currency: Shopify.currency.active,
    }).format((this.totalPriceValue + price) / 100);
  }
}

customElements.define('cart-total', CartTotal);
